import React, { useState } from "react";
import { Box, TextField, Button } from "@mui/material";
// import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import "../App.css";
import logo from "./image/Logo.png";
import Form from "./Form"

function Header(props) {
  const [showDialog, setShowDialog] = useState(false);

  const handleUploadClick = () => {
    setShowDialog(true);
  };
  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  return (
    <Box className="container">
      <div id="image">
        <img src={logo} alt="" />
      </div>

      <TextField
        placeholder="Search"
        className="SearchBar"
        value={props.searchVal}
        onChange={props.handleInput}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "gray",
            },
            "&.Mui-focused fieldset": {
              borderColor: "gray",
            },
            "&:hover fieldset": {
              borderColor: "gray",
            },
            height: "40px",
            width: "400px",
            marginTop: "10px",
            borderRadius: "0px",
            padding: "10px",
          },
          "& .MuiInputBase-input": {
            color: "white",
          },
        }}
        //   label="Search"
        variant="outlined"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon
                style={{
                  color: "white",
                  backgroundColor: "#323131",
                  width: "40px",
                  height: "37px",
                  marginRight: "-12px",
                  padding: "6px",
                }}
              />
            </InputAdornment>
          ),
        }}
      />

      <Button onClick={handleUploadClick} id="upload-btn" variant="contained">
        Upload
      </Button>

      {showDialog && <Form onHideForm={handleCloseDialog} />}
    </Box>
  );
}

export default Header;
